import React from 'react';
import { Redirect } from 'react-router-dom';
import AuthLayout from '../../layout/AuthLayout';
import FullWidthLayout from '../../layout/FullWidthLayout';
import pages from '../../pages';
import { _route } from '../../utils';

export default [
  { path: '/', component: () => <Redirect to={_route('stores')} /> },
  { path: '/amazon/auth', component: pages.auth.amzSignin, layout: AuthLayout },
  { path: '/login', component: pages.auth.register, layout: AuthLayout },
  { path: '/register', component: pages.auth.register, layout: AuthLayout },
  { path: '/logout', component: pages.auth.logout, layout: AuthLayout },
  { path: '/verify-email', component: pages.auth.verifyEmail, layout: FullWidthLayout },
  { path: '/password/reset', component: pages.auth.forgotpass, layout: AuthLayout },
  { path: '/set-password', component: pages.auth.resetpass, layout: AuthLayout },
];
